<script>
  import { extractUrls, getDomainName } from "~/utils"

  export let item
  export let registerProductRef
  export let onToggle
  export let onInput
  export let onKeyDown

  $: urls = extractUrls(item.product)
</script>

<div class="pt-1">
  <div class="flex items-center gap-3 px-2.5 py-1 bg-white/95 rounded-lg border border-border shadow-sm focus-within:border-accent focus-within:ring-2 focus-within:ring-accent/10 transition">
    <div class="flex items-center flex-none my-1 relative">
      <input
        id={`item-${item.id}`}
        type="checkbox"
        class="shopping-checkbox-input"
        checked={item.completed}
        on:change={() => onToggle(item)}
      />
      <label for={`item-${item.id}`} class="shopping-checkbox-label inline-flex items-center justify-center cursor-pointer">
        <span class="shopping-checkbox-box"></span>
      </label>
    </div>

    <div
      use:registerProductRef={item}
      class="flex-1 focus:outline-none text-lg leading-snug min-w-40 sm:min-w-48"
      class:line-through={item.completed}
      class:text-fg-muted={item.completed}
      contenteditable="true"
      on:input={(event) => onInput(item, event)}
      on:keydown={(event) => onKeyDown(item, event)}
    >{item.product || ''}</div>
  </div>
</div>

{#if urls.length > 0}
  <div class="ml-12 mt-1 flex flex-wrap gap-3 text-sm">
    {#each urls as url}
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        class="text-primary hover:text-primary-hover underline"
      >
        {getDomainName(url)}
      </a>
    {/each}
  </div>
{/if}

<style>
  .shopping-checkbox-input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  .shopping-checkbox-label {
    position: relative;
  }

  .shopping-checkbox-box {
    display: inline-block;
    width: 1.75rem;
    height: 1.75rem;
    border-radius: 0.4rem;
    border: 2px solid #C67B5C;
    background-color: #ffffff;
    box-shadow: 0 1px 2px rgba(61, 61, 61, 0.08);
    transition: background-color 0.15s ease, border-color 0.15s ease;
  }

  .shopping-checkbox-label:hover .shopping-checkbox-box {
    border-color: #A5624A;
  }

  .shopping-checkbox-input:checked + .shopping-checkbox-label .shopping-checkbox-box {
    background-color: #C67B5C;
    border-color: #C67B5C;
  }
</style>
